import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material'
import { CalendarEvent } from 'angular-calendar'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { AdministrationModel } from '../../../../models/administration.model'

@Component({
  selector: 'app-administration-man-down-dialog',
  templateUrl: './administration-man-down-dialog.component.html',
  styleUrls: ['./administration-man-down-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AdministrationManDownDialogComponent implements OnInit {
  event: CalendarEvent
  dialogTitle: string
  manDownForm: FormGroup
  action: string
  administration: AdministrationModel

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AdministrationManDownDialogComponent>,
  ) {
    this.action = 'new'

    this.administration = data.administration
    this.dialogTitle = 'Man Down'
    this.manDownForm = this.createContactForm()
  }

  ngOnInit() {}

  createContactForm() {
    return this.formBuilder.group({
      id: [this.administration.id],
      stopped_at: [this.administration.stopped_at, Validators.required],
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/administrations/administration-details/administration-man-down-dialog/administration-man-down-dialog.component.ts